export default __webpack_public_path__ + "static/media/share.010ea45b.png";